const mutations = {
  'LOGIN' (state, { user }) {
    localStorage.removeItem('user')
    if (user) {
      state.user = user.user
    } else {
      state.user = null
    }
    localStorage.setItem('user', JSON.stringify(user))
  },
  'SET_USER' (state, user) {
    state.user = user

    const userStr = localStorage.getItem('user')
    if (userStr) {
      const currentLogin = JSON.parse(userStr)
      currentLogin.user = user
      localStorage.removeItem('user')
      localStorage.setItem('user', JSON.stringify(currentLogin))
    }
  },
  'SET_PERMISSIONS' (state, permissions) {
    state.permissions = permissions
  }
}

export default mutations
